export const messages_de = {
    nameEmpty: "Name darf nicht leer sein.",
    emailEmpty: "E-Mail-Adresse darf nicht leer sein.",
    emailNotValid: "E-Mail-Adresse ist ungültig, bitte gib die korrekte E-Mail-Adresse ein.",
    locationEmpty: "Standort darf nicht leer sein.",
    profileSaved: "Profildetails gespeichert.",
    profilePic: "Profilbild gespeichert.",
    addToFavorites:"Erfolgreich zu deinen Favoriten hinzugefügt",
    removeFromFavorites:"Erfolgreich von deinen Favoriten entfernt"
};


// WEBPACK FOOTER //
// ./src/constants/messages_de.js